import { useState } from "react";
import Modal from "../ui/Modal";
import { useContactForm } from "../../hooks/useContactForm";

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export default function ContactModal({ isOpen, onClose }: Props) {
  const { submit, loading, error, success, reset } = useContactForm();

  const [form, setForm] = useState({
    name: "",
    email: "",
    message: ""
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setForm(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const submitted = await submit({
      subject: "Contact Form Submission",
      message: form.message,
      htmlMessage: `<p>${form.message}</p>`,
      name: form.name,
      email: form.email
    });

    if (submitted) {
      setTimeout(() => {
        reset();
        setForm({
          name: "",
          email: "",
          message: ""
        });
        onClose();
      }, 1500);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Contact Us">
      <p className="mb-4 text-sm text-gray-600">
        Have a question or general inquiry? Send us a message and we’ll get back
        to you shortly.
      </p>

      {success && (
        <div className="mb-3 rounded-md bg-green-50 p-2 text-sm text-green-700">
           Message sent successfully!
        </div>
      )}

      {error && (
        <div className="mb-3 rounded-md bg-red-50 p-2 text-sm text-red-600">
          {error}
        </div>
      )}

      <form className="space-y-4" onSubmit={handleSubmit}>
        <input
          name="name"
          placeholder="Full Name"
          value={form.name}
          onChange={handleChange}
          required
          className="w-full rounded-md border px-3 py-2 text-sm"
        />

        <input
          name="email"
          type="email"
          placeholder="Email Address"
          value={form.email}
          onChange={handleChange}
          required
          className="w-full rounded-md border px-3 py-2 text-sm"
        />

        <textarea
          name="message"
          placeholder="Your message"
          rows={4}
          value={form.message}
          onChange={handleChange}
          required
          className="w-full rounded-md border px-3 py-2 text-sm"
        />

        <button
          type="submit"
          disabled={loading}
          className="w-full rounded-md bg-blue-600 py-2 text-sm font-semibold text-white hover:bg-blue-700 disabled:opacity-50"
        >
          {loading ? "Sending..." : "Send Message"}
        </button>
      </form>
    </Modal>
  );
}